import { constants, typographyStyles } from "@newsela/angelou";

import { yellowDark } from "@/angelouCE/utils/constants";

const neutral = constants.colors.ui.neutral;
const white = constants.colors.ui.white[500];

const { textSObj, textXSObj } = typographyStyles;

const svgStrokeStyles = {
  stroke: neutral[600],
  strokeWidth: "3px",
};

export const buttonCss = {
  ...textXSObj,
  padding: "4px 8px",
  color: neutral[600],
  backgroundColor: yellowDark,
  letterSpacing: "1px",
  textTransform: "uppercase",
  fontWeight: "bold",

  "span:first-of-type": {
    span: {
      display: "flex",
      alignItems: "center",
      paddingRight: 0,
    },

    svg: {
      marginLeft: "8px",

      circle: {
        ...svgStrokeStyles,
      },
      path: {
        ...svgStrokeStyles,
      },
    },
  },

  "span:nth-of-type(2)": {
    svg: {
      display: "none",
    },
  },
};

export const iconCss = {
  height: "1rem",
};

export const popOutCss = {
  /**
   * Specifiying a z-index here to ensure
   * the popout overlaps the sticky bar
   */
  zIndex: 3,
};

export const popOutContentsCss = {
  ...textSObj,
  color: white,
  backgroundColor: neutral[700],
  padding: "8px 16px",
  borderRadius: "8px",
  width: "243px",
};
